import { createInertiaApp, router } from '@inertiajs/vue3'
import AppLayout from './layouts/AppLayout.vue'
import { configureApp } from './functions/configureApp'
import { configureBrowserGlobals } from './functions/configureBrowserGlobals'
import { discardStaleHistoryState } from './functions/discardStaleHistoryState'
import { usePageViewTracking } from './functions/usePageViewTracking'

/**
 * This entry point is also the SSR server's entry, and @inertiajs/vite rewrites
 * it without emitting a sourcemap, so it is kept to bare wiring. All logic that
 * could appear in a Bugsnag stack lives in the imported modules above, which
 * retain accurate source maps.
 */
const { resolvePageTitle, trackPageViews } = usePageViewTracking()

configureBrowserGlobals()
discardStaleHistoryState()

createInertiaApp({
    title: resolvePageTitle,

    layout: () => AppLayout,

    withApp: configureApp,
})

if (typeof window !== 'undefined') {
    trackPageViews(router)
}
